module.exports = __webpack_public_path__ + "static/media/drinnen_indikatoren.57fe5ece.jpg";